import React from "react";
import styles from "./styles/FoolproofSystem.module.css";
import { Reveal } from "../Home/common/Reveal";

import img1 from "../../../images/puttolight.jpg";
import img2 from "../../../images/Torque-Wrench-1.jpg";
import img3 from "../../../images/linetrace.jpg";

const items = [
  {
    title: "Pick to Light Concept",
    image: img1,
    description:
      "In assembling /making a part, it is very difficult for an operator to differentiate models and assemble accordingly. So, reading the model no with a barcode/RFID, the control unit makes the light “On” of the material correspondingly and makes the light “off” when the material is picked up.",
  },
  {
    title: "Torque Wrench",
    image: img2,
    description:
      "Alliance Automation offers solution for the torque data monitoring from torque wrench on the shop floor.",
  },
  {
    title: "Line Traceability",
    image: img3,
    description:
      "In a processing line, the product goes under several stations. Each product is given unique code, at the end of process in each station, the data is recorded against the Code. Missing process & re-processing of a product can be eliminated by pre-verification at each station. A product can be traced easily (which station is it processing at) and serialization of an assembly is maintained.",
  },
];

export default function FoolproofSystem() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Foolproof System</h2>
          <div className={styles.accent} aria-hidden="true" />
          <p className={styles.intro}>
            In an age with increasing costs and additional demands, finding a way to automate some business processes using technology may be the key to solving problems. At Alliance Automation, our engineers are problem solvers who use the latest in technology to create foolproof automation systems for businesses.
          </p>
        </div>
        <div className={styles.grid}>
          {items.map((item, index) => (
            <Reveal key={item.title} delay={index * 100}>
              <article className={styles.card}>
                <div className={styles.imageWrapper}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={styles.cardImage}
                    loading="lazy"
                  />
                </div>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <div className={styles.cardAccent} aria-hidden="true" />
                <p className={styles.cardDescription}>{item.description}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
